import React from 'react';
import MonitoringCard from './MonitoringCard';
import { MonitoringData } from '../MonitoringPage';
import { getUpdateInterval } from '../config/monitoringConfig';

interface MonitoringSectionProps {
  title: string;
  data: MonitoringData[];
  monitoringType?: 'noise' | 'tsp' | 'vibration';
  limit2xlColumns?: boolean; // 如果為 true，2xl 時只顯示 4 列
}

const MonitoringSection: React.FC<MonitoringSectionProps> = ({ title, data, monitoringType, limit2xlColumns = false }) => {
  // 響應式網格佈局：
  // 對於 Noise 和 TSP：固定 4 列
  // 對於 Vibration：
  //   - 如果 limit2xlColumns 為 true：xs=1, sm=2, md=2, lg=2, xl=2, 2xl=4
  //   - 否則：xs=1, sm=2, md=4, lg=4, xl=6, 2xl=6
  let gridCols: string;
  if (monitoringType === 'noise' || monitoringType === 'tsp') {
    // Noise 和 TSP：固定 4 列
    gridCols = 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4';
  } else if (limit2xlColumns) {
    // Vibration with limit: 2xl 時只顯示 4 列
    gridCols = 'grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5';
  } else {
    // Vibration without limit: 默認佈局
    gridCols = 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-6';
  }

  return (
    <div className="flex flex-col h-full min-h-0">
      <h2 className="text-xl font-semibold mb-4 text-white border-b border-gray-600 pb-2 flex-shrink-0">
        {title}
      </h2>
      <div className="flex-1 overflow-y-auto monitoring-scroll pr-2 min-h-0">
        {data.length === 0 ? (
          <div className="text-center text-white py-12">
            <p className="text-lg text-white">No data available</p>
            <p className="text-sm mt-2 text-white">Please select a project to view monitoring data</p>
          </div>
        ) : (
          <div className={`grid ${gridCols} gap-4 pb-2`}>
            {data.map((item) => (
              <div key={item.id} className="flex flex-col">
                <MonitoringCard
                  value={item.value}
                  unit={item.unit}
                  location={item.location}
                  locationId={item.locationId}
                  timestamp={item.timestamp}
                  variant="dark"
                  size={monitoringType === 'noise' || monitoringType === 'tsp' ? "small" : (data.length > 15 ? "small" : "large")}
                  monitoringType={monitoringType}
                  chartData={data.length > 15 ? undefined : item.chartData}
                  alertThreshold={item.alertThreshold}
                  updateInterval={monitoringType ? getUpdateInterval(monitoringType) : undefined}
                  projectName={item.projectName}
                />
                {/* 位置名稱 - 卡片下方 */}
                <div
                  className="text-sm text-white text-center mt-2 opacity-90 font-medium truncate px-2 cursor-default"
                  title={item.location}
                >
                  {item.location}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MonitoringSection;

